// callback executed when canvas was found
function handleHsForm() { 
    var subject = $('main')[0].dataset.subject;
    var subjectOption =  $('select[name="trial_session_subject"]').find('option[value="' + subject + '"]');
        
    if(subjectOption && subjectOption.length ) {
        subjectOption.prop('selected',true).change();
    }
}

// set up the mutation observer
var observer = new MutationObserver(function (mutations, me) {
  var hsForm = $('select[name="trial_session_subject"]');
  if (hsForm.length > 0) {
    handleHsForm();
    me.disconnect(); // stop observing
    return;
  }
});

// start observing
observer.observe(document, {
  childList: true,
  subtree: true
});